import moment from 'moment';

export default {
    data(){
        return {
            dateComparisonFields: [],
        }
    },
    mounted: function(){
        this.dateComparisonFields = this.getDatesComparisonFields;
    },
    computed: {
        datesComparisonEnabled: function(){
            return this.$store.getters[this.namespace + '/isDatesComparisonEnabled'];
        },
        getDatesComparisonFields: function(){
            return this.$store.getters[this.namespace + '/getDateComparisonFields'];
        },
        dateRangeA: function(){
            let metrics = this.data[0] && this.data[0].node && this.data[0].node.metrics ? this.data[0].node.metrics : [];
            let dateRangeIndex = this.getDateAIndex(metrics);
            let ranges = [];

            if (dateRangeIndex !== null)
            {
                let dateRanges = metrics[dateRangeIndex].dateRange;
                ranges = dateRanges.split(',');

            } else {
                let filtersList = this.$store.getters[this.namespace + '/getFilters'];
                let dates = filtersList.filters.dateRange;

                if (dates.startDate && dates.endDate)
                {
                    ranges = [dates.startDate.format("YYYY-MM-DD"), dates.endDate.format("YYYY-MM-DD")];
                }
            }

            if( ranges.length ) {
                ranges = ranges.map(function(dateItem){
                    return moment(dateItem).format('DD/MM/YYYY');
                });

                return ranges.join(' - ');
            }

            return 'N/A';
        },
        dateRangeB: function(){
            let metrics = this.data[0] && this.data[0].node && this.data[0].node.metrics ? this.data[0].node.metrics : [];
            let dateRangeIndex = this.getDateBIndex(metrics);
            let ranges = [];

            if (dateRangeIndex !== null)
            {
                if (this.data[0].node.metrics[dateRangeIndex] !== undefined)
                {
                    let dateRanges = this.data[0].node.metrics[dateRangeIndex].dateRange;

                    ranges = dateRanges.split(',');
                }
            } else {
                let filtersList = this.$store.getters[this.namespace + '/getFilters'];
                let dates = filtersList.filters.dateRange;

                if (dates.startDateB && dates.endDateB)
                {
                    ranges = [dates.startDateB.format("YYYY-MM-DD"), dates.endDateB.format("YYYY-MM-DD")];
                }
            }

            if( ranges.length > 0 ) {
                ranges = ranges.map(function(dateItem){
                    return moment(dateItem).format('DD/MM/YYYY');
                });

                return ranges.join(' - ');
            }

            return 'N/A';
        },
    },
    methods: {
        calculateColSpan: function(columnField, isCompareColumn = false){
            if (this.datesComparisonEnabled && this.isFieldShowDatesComparison(columnField))
            {
                if (isCompareColumn)
                    return 2;
                else
                    return 4;
            }

            return 1;
        },
        showDatesComparison(column){
            if (this.dateComparisonFields !== undefined)
            {
                let key = this.dateComparisonFields.findIndex(index => index === column.field);

                if (key != -1)
                {
                    this.dateComparisonFields.splice(key, 1);
                }
                else
                {
                    this.dateComparisonFields.push(column.field);
                }

                this.$store.dispatch(this.namespace + '/setDateComparisonFields', this.dateComparisonFields);
            }
        },
        isFieldShowDatesComparison(columnField){
            if (this.dateComparisonFields !== undefined)
            {
                let key = this.dateComparisonFields.findIndex(index => index === columnField);

                if (key !== -1) {
                    return true;
                }
            }

            return false;
        },
        getDateAIndex(data){
            let filtersList = this.$store.getters[this.namespace + '/getFilters'];
            let dates = filtersList.filters.dateRange;

            let dateRange = null;
            if (dates.startDate !== undefined && dates.endDate !== undefined)
            {
                dateRange = dates.startDate.format("YYYY-MM-DD") + ',' + dates.endDate.format("YYYY-MM-DD");
            }

            if (dateRange !== null)
            {
                let index = data.findIndex(item => item.dateRange == dateRange);

                if (index !== -1)
                {
                    return index;
                }
            }

            return null;
        },
        getDateBIndex(data){
            let filtersList = this.$store.getters[this.namespace + '/getFilters'];
            let dates = filtersList.filters.dateRange;

            let dateRange = null;
            if (dates.startDateB !== undefined && dates.endDateB !== undefined)
            {
                dateRange = dates.startDateB.format("YYYY-MM-DD") + ',' + dates.endDateB.format("YYYY-MM-DD");
            }

            if (dateRange !== null)
            {
                let index = data.findIndex(item => item.dateRange == dateRange);

                if (index !== -1)
                {
                    return index;
                }
            }

            return null;
        },
        getDateRangeAValue: function(data, columnField){
            let dateRangeAIndex = this.getDateAIndex(data);

            if (dateRangeAIndex !== null && data[dateRangeAIndex] !== undefined)
            {
                return data[dateRangeAIndex][columnField];
            }

            return 'N/A';
        },
        getDateRangeBValue: function(data, columnField, columnFieldFormat){
            let dateRangeBIndex = this.getDateBIndex(data);

            if (dateRangeBIndex !== null && data[dateRangeBIndex] !== undefined)
            {
                return data[dateRangeBIndex][columnField];
            }

            return 'N/A';
        },
        getChangeValueBetweenDates: function(data, columnField) {
            let valueA = this.getDateRangeAValue(data, columnField);
            let valueB = this.getDateRangeBValue(data, columnField);

            if (
                (valueA !== 'N/A' && valueA !== null)
                &&
                (valueB !== 'N/A' && valueB !== null)
            )
            {
                return (valueB - valueA);
            }

            return null;
        },
        getChangePercentageValueBetweenDates: function(data, columnField) {
            let valueA = this.getDateRangeAValue(data, columnField);
            let valueB = this.getDateRangeBValue(data, columnField);

            if (
                (valueA !== 'N/A' && valueA !== null)
                &&
                (valueB !== 'N/A' && valueB !== null)
                &&
                (valueB !== 0)
            )
            {
                if (valueB === valueA)
                    return 0;

                return (((valueB - valueA) / valueB) * 100);
            }

            return null;
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/datesComparisonTableMixin.js